import { Box } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { Repeat } from "lib/@components/repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { scopeLabelFor, SEARCH_SCOPES } from "routes/regime/plugins/regime-search/lib/search-scopes.js"
import { RegimeSearchScopeChip } from "routes/regime/plugins/regime-search/regime-search-scope-chip"

export function RegimeSearchScopeSelection() {
    const { searchScope, scopeCounts } = useBoundContext()
    const count = scopeCounts[searchScope] ?? 0

    return (
        <Box
            data-cy="regime-search-scope-chips"
            role="group"
            aria-label="Filter results by type, press Tab to switch"
            onMouseDown={keepInputFocus}
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.75,
                px: 1.5,
                py: 1,
                borderBottom: 1,
                borderColor: "divider",
            }}
        >
            <Repeat list={SEARCH_SCOPES} item={<RegimeSearchScopeChip />} />
            <Box component="span" aria-live="polite" sx={visuallyHidden}>
                {`Showing ${scopeLabelFor(searchScope).toLowerCase()}, ${count} results`}
            </Box>
        </Box>
    )

    function keepInputFocus(event) {
        event.preventDefault()
    }
}
